import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import { Company } from '@/types';
    import { computed, ref } from 'vue';
    import { useForm } from '@inertiajs/vue3';
    import CompanyTabs from '@/components/companies/CompanyTabs.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import ToggleActivationCompany from '@/components/companies/ToggleActivationCompany.vue';
    import ToggleRestoreCompany from '@/components/companies/ToggleRestoreCompany.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditCompany',
  props: {
    company: {},
    open: { type: Boolean },
    hideTrigger: { type: Boolean },
    afterSuccess: { type: Function }
  },
  emits: ["finish", "success", "update:open"],
  setup(__props: any, { emit: __emit }) {

    const tabs = ref<InstanceType<typeof CompanyTabs>>();

    const props = __props;

    const emit = __emit;

    const handleSuccess = () => {
        emit('success');
    };

    const dialogFormBindings = computed(() => {
        if (!props.hideTrigger) {
            return {};
        }

        return {
            open: props.open,
            hideTrigger: true,
        };
    });

    const handleUpdateOpen = (value: boolean) => {
        if (props.hideTrigger) {
            emit('update:open', value);
        }
    };

    const form = useForm({
        id: props.company.id,
        // E-conomic
        endpoint: props.company.economic_data ? 'economic' : 'plain',
        api_token: props.company.economic_data?.economic_token ?? '',
        economic_number: props.company.economic_data?.economic_number,
        sign_up_date: props.company.economic_data?.sign_up_date,
        website: props.company.website,
        economic_accounts: [],
        economic_dimensions: [],

        // Basis
        name: props.company.name,
        cvr: props.company.cvr,
        address: props.company.address,
        postal_code: props.company.postal_code,
        city: props.company.city,
        country: props.company.country,
        email: props.company.email,
        telephone: props.company.telephone,
        mobile_number: props.company.mobile_number,
        fax_number: props.company.fax_number,
        roger_invoices: props.company.roger_invoices,
        roger_receipts: props.company.roger_receipts,
        keepers_email: props.company.keepers_email,
        employee_default_id: props.company.employee_default_id,
        assistant_id: props.company.assistant_id,

        // Service
        services: [],
        num_of_vouchers: props.company.services.num_of_vouchers,
        has_payments: props.company.services.has_payments,
        fixed_price: props.company.services.fixed_price,
        price_frequency: props.company.services.price_frequency,
        voucher_limit: props.company.services.voucher_limit,
        report_deadline: props.company.services.report_deadline,
        salary_deadline: props.company.services.salary_deadline,
        vat_frequency: props.company.services.vat_frequency,
        update_frequency: props.company.services.update_frequency,
        has_e_income: props.company.services.has_e_income,
        day_frequency: props.company.services.day_frequencies ?? [],
        salary_system: props.company.services.salary_system,
        salary_two_step_approval: props.company.salary_two_step_approval,
        approver_1: props.company.salary_approval_steps?.first_approver_id,
        approver_2: props.company.salary_approval_steps?.next_approver_id,
        has_kube: props.company.services.has_kube,
        kube_id: props.company.id,
        to_keepers_kube: props.company.services.to_keepers_kube,
        kube_data_field_id: props.company.services.kube_data_field_id,

        // Outlay
        outlay_company_id: props.company.outlay_integration?.outlay_company_id,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, _mergeProps(dialogFormBindings.value, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.companies.update'),
    "query-key": [_unref(QueryKey).COMPANIES, 'economic-dimensions', props.company.id],
    title: "companies.js.company_edit",
    "success-message": "companies.updated",
    "modal-size": "sm:max-w-2xl",
    "after-success": _ctx.afterSuccess,
    onSuccess: handleSuccess,
    onFinish: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('finish'))),
    "onUpdate:open": handleUpdateOpen
  }), {
    footerActions: _withCtx(() => [
      (_ctx.company.deleted_at)
        ? (_openBlock(), _createBlock(ToggleRestoreCompany, {
            key: 0,
            company: _ctx.company
          }, null, 8, ["company"]))
        : (_openBlock(), _createBlock(ToggleActivationCompany, {
            key: 1,
            company: _ctx.company
          }, null, 8, ["company"]))
    ]),
    default: _withCtx(() => [
      _createVNode(CompanyTabs, {
        form: _unref(form),
        company: _ctx.company,
        ref_key: "tabs",
        ref: tabs
      }, null, 8, ["form", "company"])
    ]),
    _: 1
  }, 16, ["form", "route", "query-key", "after-success"]))
}
}

})